import { ButtonProps } from "@/components/Button";
import { ButtonWithSigninDialogFallback } from "@/components/Modal/ButtonWithSigninDialogFallback";
import { ConfirmDialog } from "@/components/Modal/ConfirmDialog";
import { LearningOpportunity } from "@/server/backend-api";
import {
  LearningOpportunityStatus,
  LearningOpportunityType
} from "@/server/backend-api/generated";
import { mcn } from "@/utils";
import { useState } from "react";

type Props = {
  learningOpportunity: LearningOpportunity;
  onSimplifiedProcessWithoutDocumentsJoinCallback?: () => void;
  isSticking: boolean;
};

export const LearningOpportunityApplyButton = ({
  learningOpportunity: learningOpp,
  onSimplifiedProcessWithoutDocumentsJoinCallback,
  isSticking,
}: Props) => {
  const [showJoinDialog, setShowJoinDialog] = useState(false);

  const canApply =
    learningOpp.status === LearningOpportunityStatus.OpenForApplication &&
    !learningOpp.simplifiedAdmissionProcessAndIsFull &&
    !learningOpp.userAdmissionData;

  if (!canApply) {
    return null;
  }

  const canApplyAndIsSimplifiedWithoutDocuments =
    canApply && learningOpp.simplifiedAdmissionProcessWithNoDocuments === true;
  const learningOppTypeName =
    learningOpp.type === LearningOpportunityType.Challenge
      ? "challenge"
      : "module";

  const sharedButtonProps: ButtonProps = canApplyAndIsSimplifiedWithoutDocuments
    ? {
        kind: "secondary",
        label: "Join",
        onClick: () => setShowJoinDialog(true),
      }
    : {
        kind: "secondary",
        label: "Apply",
        href: `${learningOpp.url}/apply`,
      };

  return (
    <>
      <ButtonWithSigninDialogFallback
        buttonProps={{
          ...sharedButtonProps,
          size: "small",
          className: "hidden laptop:inline-flex",
        }}
      />
      <ButtonWithSigninDialogFallback
        buttonProps={{
          ...sharedButtonProps,
          className: mcn(
            "laptop:hidden",
            !isSticking && "hidden",
            "fixed bottom-md right-md",
            "shadow-elevation-2"
          ),
        }}
      />

      <ConfirmDialog
        open={showJoinDialog}
        onClose={() => setShowJoinDialog(false)}
        onCancelClick={() => setShowJoinDialog(false)}
        title={`Join ${learningOppTypeName}`}
        description={`By clicking Join you will join this ${learningOppTypeName}.`}
        confirmActionText="Join"
        confirmType="click"
        onConfirmClick={() => {
          if (onSimplifiedProcessWithoutDocumentsJoinCallback) {
            onSimplifiedProcessWithoutDocumentsJoinCallback();
          }
          setShowJoinDialog(false);
        }}
      />
    </>
  );
};
